import {
  Accordion,
  Box,
  Modal,
  Text,
  useBreakpoint,
} from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import classNames from "classnames/dedupe";
import { useCallback, useState } from "react";
import { customBreakpoints } from "../../../../../constants/breakpoints";
import type { Cover as CoverType } from "../../../types";
import type { CoverLimitProps } from "../../CoverLimit";
import { CoverLimit } from "../../CoverLimit";
import { CoverageItems } from "./CoverageItems";

type CoverageProps = {
  covers: CoverType[];
  className?: string;
};

export type ViewExcessModalProps = {
  displayName: string;
  excesses: CoverLimitProps[];
};

export const Coverage = ({ covers, className }: CoverageProps) => {
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState<ViewExcessModalProps>({
    displayName: "",
    excesses: [],
  });
  const { down } = useBreakpoint(customBreakpoints);
  const isMobileDevice = down("md");
  const { snowplow } = useSnowplowContext();

  const classes = classNames("mobius-quote-card__coverage", className);

  const handleOpen = useCallback(
    ({ displayName, excesses }: ViewExcessModalProps) => {
      setModalData({ displayName, excesses });
      setOpen(true);
    },
    [],
  );

  const handleOpenAccordion = useCallback(() => {
    snowplow?.trigger("coverageInfoClicked", {
      deviceType: isMobileDevice ? "mobile" : "desktop",
    });
  }, [isMobileDevice, snowplow]);

  return (
    <>
      <Box className={classes} data-testid="quote-coverage-uk">
        {isMobileDevice ? (
          <Accordion
            showText="Show coverage info"
            hideText="Hide coverage info"
            onOpen={handleOpenAccordion}
          >
            <CoverageItems covers={covers} onOpen={handleOpen} />
          </Accordion>
        ) : (
          <>
            <Text className="mobius-quote-card__coverage-title" variant="h3">
              Coverage Information
            </Text>
            <CoverageItems covers={covers} onOpen={handleOpen} />
          </>
        )}
        <Modal
          className="mobius-quote-card__coverage-item-excess-modal"
          isOpen={open}
          onClose={() => setOpen(false)}
        >
          <Modal.Header>{modalData.displayName} excess</Modal.Header>
          <Modal.Content>
            {modalData.excesses.map(cover => (
              <CoverLimit
                key={cover.title}
                {...cover}
                product={modalData.displayName}
              />
            ))}
          </Modal.Content>
        </Modal>
      </Box>
    </>
  );
};
